import { ChevronsLeft, ChevronsRight } from "lucide-react"

import { getPages } from "@/util/getPages.ts"

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "./ui/pagination.tsx"

import type { Table } from "@tanstack/react-table"

export default function Paginator<T>({ table }: { table: Table<T> }) {
  return (
    <Pagination className="flex gap-2 p-2 bg-muted sticky bottom-0">
      <PaginationContent>
        <PaginationItem>
          <PaginationLink
            onClick={table.firstPage}
            className={`select-none ${
              !table.getCanPreviousPage() && "pointer-events-none opacity-50"
            }`}
          >
            <ChevronsLeft />
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationPrevious
            onClick={table.previousPage}
            className={`select-none ${
              !table.getCanPreviousPage() && "pointer-events-none opacity-50"
            }`}
          />
        </PaginationItem>

        {getPages(table.getPageCount(), table.getState().pagination.pageIndex, 9).map((page) => (
          <PaginationItem key={page}>
            <PaginationLink
              className={`select-none`}
              onClick={() => table.setPageIndex(page)}
              isActive={page == table.getState().pagination.pageIndex}
            >
              {page + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem>
          <PaginationNext
            onClick={table.nextPage}
            className={`select-none ${!table.getCanNextPage() && "pointer-events-none opacity-50"}`}
          />
        </PaginationItem>
        <PaginationItem>
          <PaginationLink
            onClick={table.lastPage}
            className={`select-none ${!table.getCanNextPage() && "pointer-events-none opacity-50"}`}
          >
            <ChevronsRight />
          </PaginationLink>
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
